module.exports = __webpack_public_path__ + "img/de-product-classify_img_11.4276745e.jpg";